module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (58).234b1ea3.jpg";